export const tinyMCE= 'tinyMCE';
export const quetion= 'quetion';
export const file= 'file';
export const image= 'image';